import React from 'react'
import Dropdown from 'components/common/dropdowns/Dropdown'
import colors from 'utility/colors'
import { usePartnerIndustryTypes } from 'hooks/api/partner/usePartnerIndustryTypes'
import FormLabel from 'components/common/forms/elements/FormLabel'

export const PartnerIndustryTypesDropdown = ({
	title = 'Select an Industry Type',
	onSelect,
	value,
	disabled = false,
	labelStyle = {},
	style = {},
}) => {
	const { data: industryTypes } = usePartnerIndustryTypes()

	const defaultLabelStyle = {
		color: colors.GRAY,
		fontWeight: 'bold',
		fontSize: '14px',
		marginBottom: 7,
	}

	const selectedValue = industryTypes?.find((industryType) => industryType.id === value)
	console.log('Value: ', value)
	console.log({ industryTypes })
	console.log('Selected VALUE: ', selectedValue)
	return (
		<div style={style}>
			<FormLabel required style={{ ...defaultLabelStyle, ...labelStyle }}>
				INDUSTRY TYPE
			</FormLabel>
			<Dropdown
				cardStyle={{ width: '100%', maxHeight: 300, overflowY: 'auto' }}
				style={{ width: '100%', height: '100%' }}
				color={colors.BLACK}
				onSelect={onSelect}
				buttonStyle={{
					backgroundColor: colors.WHITE,
					borderColor: colors.WHITE,
				}}
				disabled={disabled}
				defaultTitle={title}
				options={industryTypes?.map((industryType) => {
					return {
						title: industryType.name,
						data: industryType,
						onClick: onSelect,
					}
				})}
			>
				{selectedValue?.name || title}
			</Dropdown>
		</div>
	)
}
